/**
 * [ File :: G_Animate.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/animate/G_Animate.js
 * @목적 : 그리드타입에서 사용하는 애니메이션 객체입니다.
 * @진행 : 종료
 * @주의 : 그리드에서만 사용하는 애니메이션은 이곳에 작성해주세요.
 * @이슈 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Animate        from 'canvas/base/dev/animate/B_Animate';
import B_TweenObject    from 'canvas/base/dev/animate/tween/B_TweenObject';
import B_ProtonParticle from 'canvas/base/dev/animate/proton/B_ProtonParticle';

const G_Animate = (function(){

	return class extends B_Animate {
		constructor(canvas) {
			super(canvas, new B_TweenObject(canvas), new B_ProtonParticle(canvas));
		}
	}
}());

export default G_Animate;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/animate/G_Animate.js